(() => {
  function init() {
    const root = document.getElementById('anessa-product');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const product = JSON.parse(root.querySelector('[data-anessa-product]').textContent);
    const brush = JSON.parse(root.querySelector('[data-anessa-brush]').textContent);
    const i18n = JSON.parse(root.querySelector('[data-anessa-i18n]').textContent);
    const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency || 'USD'}).format(cents/100);
    const form = root.querySelector('#anessa-product-form');
    const submit = form.querySelector('[type=submit]');
    const error = root.querySelector('[data-product-error]');
    let busy = false;
    let slide = 0;
    const showError = (node,message) => {node.textContent=message;node.hidden=!message;};
    const selection = row => {
      const color = row.querySelector('input:checked')?.value;
      const size = row.querySelector('select').value;
      return product.variants.find(v => v.option1===color && v.option2===size);
    };
    const refreshRow = row => {
      const v = selection(row);
      const img = row.querySelector('img');
      if (v?.featured_image?.src && img) {const imageUrl=new URL(v.featured_image.src,location.origin);imageUrl.searchParams.set('width','100');img.src=imageUrl.href;img.removeAttribute('srcset');img.alt=v.title;}
      row.querySelector('.an-selected-color').textContent=v?.option1 || '';
      row.dataset.available=String(!!v?.available);
    };
    const updatePack = () => {
      const qty=Number(root.querySelector('[name=anessa-pack]:checked').value);
      root.querySelectorAll('[data-pack]').forEach(pack=>{const selected=Number(pack.dataset.pack)===qty;pack.classList.toggle('is-selected',selected);pack.querySelector('.an-pack-rows').hidden=!selected;});
      root.querySelector('[data-bonus-gift]')?.classList.toggle('is-locked',qty!==6);
      form.elements.quantity.value=qty;
      const v=selection(root.querySelector('.an-pack.is-selected .an-variant-row'));
      if(v)form.elements.id.value=v.id;
    };
    root.querySelectorAll('[name=anessa-pack]').forEach(input=>input.addEventListener('change',updatePack));
    root.querySelectorAll('.an-variant-row').forEach(row=>{refreshRow(row);row.addEventListener('change',()=>{refreshRow(row);updatePack();});});

    const gallery=root.querySelector('.an-gallery-main');
    const galleryTrack=root.querySelector('.an-gallery-track');
    const slides=[...root.querySelectorAll('[data-slide]')];
    const thumbnails=[...root.querySelectorAll('[data-thumbnail]')];
    const thumbTrack=root.querySelector('.an-thumbnails');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncSlide=()=>{
      slide=Math.max(0,Math.min(slides.length-1,Math.round(galleryTrack.scrollLeft/Math.max(1,galleryTrack.clientWidth))));
      thumbnails.forEach((el,i)=>el.setAttribute('aria-pressed',String(i===slide)));
      const thumb=thumbnails[slide];
      if(thumb){
        const left=thumb.getBoundingClientRect().left-thumbTrack.getBoundingClientRect().left+thumbTrack.scrollLeft;
        if(left<thumbTrack.scrollLeft || left+thumb.offsetWidth>thumbTrack.scrollLeft+thumbTrack.clientWidth){
          thumbTrack.scrollTo({left:Math.max(0,left-(thumbTrack.clientWidth-thumb.offsetWidth)/2),behavior:reduced.matches?'instant':'smooth'});
        }
      }
    };
    const showSlide=index=>{
      slide=(index+slides.length)%slides.length;
      galleryTrack.scrollTo({left:slide*galleryTrack.clientWidth,behavior:reduced.matches?'instant':'smooth'});
    };
    thumbnails.forEach(btn=>btn.addEventListener('click',()=>showSlide(Number(btn.dataset.thumbnail))));
    root.querySelectorAll('[data-gallery-step]').forEach(btn=>btn.addEventListener('click',()=>showSlide(slide+Number(btn.dataset.galleryStep))));
    gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();showSlide(slide+(e.key==='ArrowRight'?1:-1));}});
    galleryTrack.addEventListener('scroll',syncSlide,{passive:true});
    if(typeof ResizeObserver==='function'){
      const galleryObserver=new ResizeObserver(()=>galleryTrack.scrollTo({left:slide*galleryTrack.clientWidth,behavior:'instant'}));
      galleryObserver.observe(galleryTrack);
    }
    syncSlide();
    form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy)return;busy=true;submit.disabled=true;submit.textContent=i18n.adding;showError(error,'');
      try{
        const active=root.querySelector('.an-pack.is-selected');const items=[];
        for(const row of active.querySelectorAll('.an-variant-row')){const v=selection(row);if(!v?.available)throw new Error(i18n.unavailable);const existing=items.find(i=>i.id===v.id);if(existing)existing.quantity++;else items.push({id:v.id,quantity:1});}
        if(root.querySelector('[data-brush]')?.checked){if(!brush?.available)throw new Error(i18n.unavailable);items.push({id:brush.id,quantity:1});}
        if (!window.AnessaCart) throw new Error(i18n.error);
        await window.AnessaCart.add(items);
      }catch(e){showError(error,e.message||i18n.error);}finally{busy=false;submit.disabled=false;submit.textContent=i18n.add;}
    });
    const countdown=root.querySelector('[data-countdown]');
    function tick(){const now=new Date();const next=new Date(now);next.setHours(24,0,0,0);const s=Math.floor((next-now)/1000);countdown.textContent=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(n=>String(n).padStart(2,'0')).join(' : ');}
    tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
    document.addEventListener('keydown',e=>{
      const modal=root.querySelector('#sbz-modal');if(!modal||modal.hidden||e.key!=='Tab')return;
      const focusables=[...modal.querySelectorAll('button,input,select,a[href]')].filter(n=>!n.disabled&&n.getClientRects().length);
      const first=focusables[0],last=focusables.at(-1);
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    updatePack();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
